<template lang="pug">
    m-list(v-bind="$attrs" v-on="$listeners")
        template(#template="{item, index}")
            v-layout( class="m-card-effectiveness-option-questions__body")
                v-flex(xs12)
                    e-typography-links-small(
                        tabindex="0"
                        class="m-card-effectiveness-option-questions__item"
                        id="#section2Anchor"
                        @click="$emit('click:question', {item:item, questionKey: index})"
                        @keyup.enter="$emit('click:question', {item:item, questionKey: index})"
                        style="cursor:pointer")
                        component(:is="sectionIcons[index]" @click.native.stop="openIconInfoDialog" v-if="sectionIcons[index]" class="m-card-effectiveness-option-questions__icon")
                        | {{item.title}}


</template>

<script>
    import MList from "@modules/lists/m-list";
    import assessment from "@mixins/helpers/_assessment";
    import {getAnswer} from "@utils/assessmentAnswers";
    import statusIconDialog from "@mixins/additional/_statusIconDialog";

    export default {
        name: "m-list-effectiveness-option-questions",
        components: {MList},
        mixins: [assessment, statusIconDialog],
        props: {
            sectionKey: {
                type: Number,
                required: true
            },
            mainSectionKey: {
                type: Number,
                required: true
            },
            optionSectionKey: {
                type: Number,
                required: true
            },
            answers: {
                type: Array,
                required: true
            }
        },
        computed: {
            optionsAnswers() {
                //TODO remove "0" from keys
                let keys = [this.mainSectionKey, this.sectionKey, 0, this.optionSectionKey];
                return this.getAnswer(keys);
            },
            sectionIcons() {
                let result = [];
                let cond = !!this.optionsAnswers && !!this.optionsAnswers.children
                if (cond) {
                    this.optionsAnswers.children.forEach((item) => {
                        result.push(this.assessmentHelper.questionIcon(item))
                    });
                }
                return result;
            }
        },
        methods: {
            getAnswer(keys) {
                return getAnswer(this.answers, keys)
            },
        }
    }
</script>

<style lang="scss" scoped>
    .m-card-effectiveness-option-questions {
        &__body {
            padding: 0px !important;

            .flex {
                padding: 4px 12px;
            }

            &:hover {
                background-color: var(--v-secondary-darken1);
            }
        }

        &__item {
            margin-left: 70px;
            font-weight: normal;
            position: relative;
            outline: none;

            &:focus {
                border-bottom: 2px solid var(--v-primary-base);
            }

            @include updatedMedia(sm) {
                margin-left: 35px;
                display: block;
            }

        }

        &__icon {
            position: absolute;
            left: -35px;
            top: -2px;
        }
    }
</style>
